const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.40008 8.00006L0.000170852 14.4L1.60015 15.9999L8.00006 9.60004L14.3998 15.9998L15.9998 14.3998L9.60004 8.00006L16 1.6001L14.4 0.000117829L8.00006 6.40008L1.59998 0L0 1.59998L6.40008 8.00006Z" />
  </svg>
);

export default CloseIcon;
